import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pirSectionHeading: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.pir-section-heading',
		defaultMessage: 'Post-incident reviews (PIRs)',
		description: 'Heading of the settings section which controls "Post Incident Reviews"',
	},
	pirSectionDescription: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.pir-section-description',
		defaultMessage:
			'Create post-incident reviews to document the incident timeline, find root causes of the incident, and share learnings with your team.',
		description: 'Description text, explaining settings of "Post Incident Reviews"',
	},
	pirLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.pir-learn-more-link',
		defaultMessage: ' Learn more about post-incident reviews.',
		description: 'Learn More link for PIR',
	},
	pirSaveChangesButtonText: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.pir-save-changes-button-text',
		defaultMessage: 'Save changes',
		description: 'Save changes made to the "Post Incident Reviews" settings text',
	},
	pirDiscardChangesButtonText: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.pir-discard-changes-button-text',
		defaultMessage: 'Discard changes',
		description: 'Discard changes made to the "Post Incident Reviews" settings text',
	},
	errorTitle: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.error-title',
		defaultMessage: "We couldn't load incident settings",
		description:
			'The title text in the status flag if the confluence configuration can not be fetched.',
	},
	errorDescription: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.error-description',
		defaultMessage: 'Wait a moment then refresh the page to try again.',
		description:
			'The description text in the status flag if the responder alerts configuration status can not be fetched.',
	},
	upgradePlanInfo: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.upgrade-plan-info',
		defaultMessage: 'Upgrade to a Premium or Enterprise plan to use this feature.',
		description:
			'Message of warning popper to forward user to upgrade their plan to premium or enterprise',
	},
	ctaLink: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.cta-link',
		defaultMessage: 'Upgrade now',
		description: 'CTA link that redirects user to upgrade page',
	},
	premiumLozenge: {
		id: 'servicedesk-incident-management-settings.post-incident-reviews.premium-lozenge',
		defaultMessage: 'Premium',
		description: 'Premium lozenge text',
	},
});
